/// <amd-module name="VSS/Diagnostics/Dialog/PerfInsightsDialog" />
import React = require("react");
import { Components, VssComponent } from "VSS/Platform/Layout";
import { Dialog } from "VSSUI/Dialog";
import { IPerformanceInsight } from "VSS/Platform/Performance";

interface PerfInsightsDialogProps {
    onDismiss: () => void;
    insightsForDialog: IPerformanceInsight[];
    displayedInsightsGroup: string;
}

class PerfSettingsDialog extends VssComponent<PerfInsightsDialogProps> {
    public render(): JSX.Element {
        const { insightsForDialog, onDismiss, displayedInsightsGroup } = this.props;

        return (
            <Dialog
                onDismiss={onDismiss}
                calloutContentClassName="performance-dialog performance-insights dialog-full-size"
                lightDismiss={false}
                showCloseButton={true}
                titleProps={{ text: displayedInsightsGroup }}
            >
                {insightsForDialog.map((insight, index) => {
                    return (
                        <div key={"insight-" + index} className="performance-insight">
                            <div className="insight-title">{insight.title}</div>
                            {insight.description && <div className="insight-description">{insight.description}</div>}
                        </div>
                    );
                })}
            </Dialog>
        );
    }
}

Components.add("vss.perf-insights-dialog", PerfSettingsDialog);
